export default __webpack_public_path__ + "static/whatsappStore-icon-menu-701b20a7c40ac6c6737178667f4d6f42.svg";